import config from './config';
import { getCookie } from './setCookie';

// The panel host a request may go to: the `panel` cookie when it names a TGM API host, else the
// default host. A missing, empty, retired or planted cookie must never reach config.generateUrl,
// which throws on it (SE-PANEL-HOST-TOKEN, CO-COVER-STARTUP-HOST).
export const trustedPanelHost = (cookiePanel = getCookie('panel')) =>
  config.isTrustedApiHost(cookiePanel) ? cookiePanel : config.urlGgCloud;
